import { lazy } from 'react'

export const EmailVariant1 = lazy(() => import('./EmailVariant1'))
